<template>
  <el-dialog v-model="dialogVisible" title="栏目参照" @opened="opened">
    <div class="list">
      <div class="list-filter">
        <el-form :inline="true" :model="queryEntity" class="demo-form-inline">
          <el-form-item label="编码">
            <el-input size="medium" v-model="queryEntity.code" placeholder="编码" clearable></el-input>
          </el-form-item>
          <el-form-item label="名称">
            <el-input size="medium" v-model="queryEntity.name" placeholder="名称" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <el-button class="list-btn-select" size="small" type="primary" @click="selectList">查询</el-button>
            <el-button class="list-btn-reset" size="small" @click="resetSelect">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="list-table">
        <el-table ref="tableRefer" row-key="id" lazy :data="dataList" @current-change="handleCurrentChange" default-expand-all :tree-props="{children: 'childCategorys'}" :header-cell-class-name="headerCellClass" :max-height="400" highlight-current-row border size="medium" @sort-change='sortChange' :default-sort="{ prop: 'sortNo', order: 'descending' }">
          <el-table-column prop="id" label="ID" width="80"> </el-table-column>
          <el-table-column prop="code" label="编码" width="120"> </el-table-column>
          <el-table-column prop="name" label="名称" width="300"> </el-table-column>
          <el-table-column prop="stateName" label="状态" width="100"> </el-table-column>
          <el-table-column prop="navName" label="导航栏" width="100"> </el-table-column>
          <el-table-column prop="remark" label="备注"> </el-table-column>
        </el-table>
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button ref="btnConfirm" type="primary" @click="confirm">确定</el-button>
      </span>
    </template>
  </el-dialog>
</template>

<script lang="ts">
import { Category } from "@/script/apps/cms/entity/CmsEntity";
import { Options } from "vue-class-component";
import { BaseList } from "@/script/core/view/BaseList";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { CategoryService } from "@/script/apps/cms/service/CategoryService";
import { CallBack } from "@/script/core/service/DataService";
import { ElMessage } from "element-plus";

@Options({})
export default class CategoryRefer extends BaseList {
  private queryEntity: Category = {};

  private dataList: Category[] = [];

  private service = new CategoryService();

  private dialogVisible = false;

  private callBack: CallBack<Category> | null = null;

  private currentRow: Category | null = null;

  public initData(): ServiceContext {
    this.queryParam.pager = {
      pageIndex: 1,
      pageSize: 1000,
      total: 0,
      sorters: [{ prop: "sortNo", sortField: "cc.sort_no", sortMode: "desc" }],
    };
    return ServiceFactory.build(
      "biz_cms_category",
      "/cms/category",
      "/cms/category",
      this.service
    );
  }

  public initQueryEntity() {
    this.queryEntity = {
      code: "",
      name: "",
    };
    return this.queryEntity;
  }

  public afterLoadList(data: any): void {
    const dataList: Category[] = data.list as Category[];
    dataList.forEach((item) => {
      item.staticizeName = item.staticize ? "是" : "否";
      item.navName = item.nav ? "是" : "否";
    });

    const dataTree: Category[] = [];
    dataList.forEach((item) => {
      if (!item.parentId) {
        item.childCategorys = [];
        dataTree.push(item);
        this.generateTree(dataList, item);
      }
    });
    this.dataList = dataTree;
    if (this.$refs.tableRefer) {
      (this.$refs.tableRefer as any).setCurrentRow();
    }
  }

  private generateTree(dataList: Category[], parent: Category) {
    const childs: Category[] = [];
    dataList.forEach((item) => {
      if (item.parentId === parent.id) {
        childs.push(item);
        // 递归
        this.generateTree(dataList, item);
      }
    });
    if (childs.length > 0) {
      parent.childCategorys = childs;
    }
  }

  handleCurrentChange(row: Category) {
    this.currentRow = row;
  }

  public show(callBack: CallBack<Category>) {
    this.currentRow = null;
    this.callBack = callBack;
    this.dialogVisible = true;
  }

  private opened() {
    if (this.$refs.tableRefer) {
      (this.$refs.tableRefer as any).setCurrentRow();
    }
  }

  confirm() {
    if (this.currentRow === null) {
      ElMessage.error("请选择栏目！");
      return;
    }
    this.dialogVisible = false;
    if (this.callBack) {
      this.callBack(this.currentRow!);
    }
  }
}
</script>
